import React from "react";
import PropTypes from "prop-types";
import GatsbyImage from "gatsby-image";
import useTracedImage from "hooks/use-traced-image.js";
import volumeIdEnum from "constants/volumeIdEnum.js";

const Link = props => {
  const Tag = props.data.imageLink ? "a" : "div";
  return (
    <Tag
      href={props.data.imageLink ? props.data.imageLink : "#"}
      onClick={e => (props.data.imageLink ? true : e.preventDefault())}
      target={props.data.imageLink ? "_blank" : null}
    >
      {props.children}
    </Tag>
  );
};

const Image = props => {
  const fluidImage = useTracedImage(props.data ? props.data.filename : null);

  if (process.env.SERVER_ENV === "production") {
    return (
      <Link data={{ imageLink: props.data.imageLink }}>
        <GatsbyImage
          fluid={fluidImage}
          alt={props.alt}
          className={props.className}
          placeholderClassName={props.noPlaceholderClassName ? "" : props.className}
          style={
            props.data.width && props.data.height
              ? { width: +props.data.width, height: +props.data.height }
              : null
          }
        />
      </Link>
    );
  }

  if (props.data !== undefined) {
    return (
      <Link data={{ imageLink: props.data.imageLink }}>
        <img
          className={props.className}
          src={volumeIdEnum[props.data.volumeId] + props.data.filename}
          alt={props.data.title || props.data.filename}
        />
      </Link>
    );
  }

  return null;
};

Image.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    title: PropTypes.string,
    filename: PropTypes.string,
    volumeId: PropTypes.number,
    imageLink: PropTypes.string
  }),
  noPlaceholderClassName: PropTypes.bool
};

export default Image;
